module.exports = __webpack_public_path__ + "static/media/punchy.1b5bc76a.jpg";